import {
  css,
  customElement,
  GenesisElement,
  html,
  observable,
  repeat,
} from '@genesislcap/web-core';
import { BondSeries } from '../../deal-detail/deal-detail.types';
import {
  labelStyles,
  thinHorizontalScrollbarStyles,
  THIN_HORIZONTAL_SCROLL_CLASS,
} from '../../../../styles/styles';
import { createSeriesInfoItems, SeriesInfoItem } from '../../deal-detail/deal-detail.util';

@customElement({
  name: 'deal-series-information',
  template: html<DealSeriesInformation>`
    <div class="deal-series-information ${THIN_HORIZONTAL_SCROLL_CLASS}">
      ${repeat(
        (x) => x.seriesInfoItems,
        html`
          <div class="deal-series-information-item">
            <div class="label">${(x) => x.label}</div>
            <div class="value" title="${(x, c) => c.parent.getTooltipText(x)}">${(x) => x.value}</div>
          </div>
        `,
      )}
    </div>
  `,
  styles: css`
    ${thinHorizontalScrollbarStyles}
    :host {
      display: block;
    }
    ${labelStyles}
    .label {
      white-space: nowrap;
    }

    .deal-series-information {
      display: flex;
      flex: 0;
      align-items: center;
      background: #1f2126;
      padding: 10px 0 0 0;
      min-width: 0;
      max-width: 100%;
    }

    .deal-series-information-item {
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px;
      border-right: calc(var(--stroke-width) * 1px) solid var(--neutral-stroke-divider-rest);
      flex-shrink: 0;
      white-space: nowrap;

      .value {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .deal-series-information-item:last-child {
      border-right: none;
    }

    rapid-tooltip::part(tooltip) {
      min-width: 400px;
      background-color: black;
      color: white;
      border-color: var(--neutral-stroke-divider-rest);
      padding: 5px 5px;
    }
  `,
})
export class DealSeriesInformation extends GenesisElement {
  @observable series: BondSeries;
  @observable bondSeriesList: BondSeries[]; // All series for conditional field display when values differ
  @observable labels: Array<{ label: string; value: string }> = [];

  get seriesInfoItems(): SeriesInfoItem[] {
    return createSeriesInfoItems(this.bondSeriesList, this.series, this.labels);
  }

  getTooltipText(item: SeriesInfoItem): string {
    return item.label === 'Call Features' && item.fullValue !== item.value
      ? item.fullValue
      : '';
  }
}
